import { render, staticRenderFns } from "./ChengYaoDetail.vue?vue&type=template&id=a44a8e48&scoped=true"
import script from "./ChengYaoDetail.vue?vue&type=script&lang=js"
export * from "./ChengYaoDetail.vue?vue&type=script&lang=js"
import style0 from "./ChengYaoDetail.vue?vue&type=style&index=0&id=a44a8e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44a8e48",
  null
  
)

export default component.exports